export default {
    path: '/payment/:id?',
    name: 'payment',
    component: () => import('../views/Global/PaymentView.vue'),
    meta: {
        title: 'PAYMENT',
    },
};
